import { supabase } from '@/integrations/supabase/client';
import { UserRole } from '@/types';

// Login with email and password
export const loginWithEmail = async (email: string, password: string): Promise<{ data: { user: any; session: any; } | null, error: any }> => {
  console.log('Auth Method: Logging in with email:', email);
  try {
    // Consider if signOut is always needed here. It might interrupt existing valid sessions unnecessarily.
    // await supabase.auth.signOut(); 
    
    const { data, error } = await supabase.auth.signInWithPassword({
      email,
      password,
    });

    if (error) {
      console.error('Auth Method Error: Login failed:', error.message);
      // Don't throw here, let the caller (provider) handle the error and UI.
      return { data: null, error }; 
    }
    
    console.log('Auth Method: Login successful, user:', data.user?.id);
    // The onAuthStateChange listener in the provider should handle profile fetching.
    return { data, error: null }; 
  } catch (err) {
    // Catch unexpected errors during the process
    console.error('Auth Method Error: Unexpected error during login:', err);
    return { data: null, error: err instanceof Error ? err : new Error('Unknown login error') };
  }
};

// Register with email and password
export const registerWithEmail = async (email: string, password: string, role: UserRole, metadata?: Record<string, any>): Promise<{ data: { user: any; session: any; } | null, error: any }> => {
  console.log('Auth Method: Registering new user:', email, 'role:', role);
  
  try {
    const userMetadata = {
      role: role,
      ...(metadata || {}) // Ensure metadata like displayName can be passed
    };
    
    const { data, error } = await supabase.auth.signUp({
      email,
      password,
      options: {
        data: userMetadata, // Pass metadata here
        // emailRedirectTo: 'YOUR_CONFIRMATION_URL', // Optional: specify confirmation URL
      },
    });

    if (error) {
      console.error('Auth Method Error: Registration failed:', error.message);
      return { data: null, error };
    }
    
    // Log success, confirmation status handled by caller (provider) via toast based on response
    console.log('Auth Method: Registration successful for user:', data.user?.id);
    
    // No need to create profile here, should be handled by trigger or initial fetch on login

    return { data, error: null };
  } catch (err) {
    console.error('Auth Method Error: Unexpected error during registration:', err);
     return { data: null, error: err instanceof Error ? err : new Error('Unknown registration error') };
  }
};

// Logout the user
export const logout = async (): Promise<{ error: any }> => {
  console.log('Auth Method: Logging out...');
  try {
    const { error } = await supabase.auth.signOut();
    if (error) {
      console.error('Auth Method Error: Logout failed:', error.message);
      return { error };
    }
    console.log('Auth Method: Logout successful.');
    return { error: null };
  } catch (err) {
    console.error('Auth Method Error: Unexpected error during logout:', err);
    return { error: err instanceof Error ? err : new Error('Unknown logout error') };
  }
};
